import { Link } from 'react-router-dom';
import type { ComicData } from '@/mocks/comics';

interface ComicCardProps {
  comic: ComicData;
  showStats?: boolean;
}

export default function ComicCard({ comic, showStats = true }: ComicCardProps) {
  const formatViews = (num: number) => {
    if (num >= 10000) return `${(num / 10000).toFixed(1)}万`;
    return num.toString();
  };

  return (
    <Link
      to={`/article/${comic.id}`}
      className="group block rounded-lg overflow-hidden bg-background-50 border border-background-200/70 hover:border-primary-200 transition-all duration-300 hover:-translate-y-1"
      data-product-shop
    >
      {/* Cover */}
      <div className="relative aspect-[3/4] overflow-hidden bg-background-100">
        <img
          src={comic.coverImage}
          alt={`${comic.title} - 韩国漫画无删减下拉式在线阅读`}
          title={`${comic.title} - 免费韩漫`}
          className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
        />
        {/* Status badge */}
        <span
          className={`absolute top-2 right-2 px-2 py-0.5 rounded-full text-xs font-medium ${
            comic.status === '连载中'
              ? 'bg-primary-500 text-background-50'
              : 'bg-foreground-500 text-background-50'
          }`}
        >
          {comic.status}
        </span>
        {/* Rating */}
        <div className="absolute bottom-2 left-2 flex items-center gap-1 bg-background-950/70 backdrop-blur-sm text-background-50 px-2 py-0.5 rounded-full text-xs">
          <i className="ri-star-fill text-accent-500 text-[10px]"></i>
          <span>{comic.rating}</span>
        </div>
      </div>

      {/* Info */}
      <div className="p-3">
        <h3 className="text-sm font-medium text-foreground-900 group-hover:text-primary-600 transition-colors line-clamp-1 font-heading">
          {comic.title}
        </h3>
        <p className="text-xs text-foreground-500 mt-1">{comic.author}</p>
        {showStats && (
          <div className="flex items-center gap-3 mt-2 text-xs text-foreground-400">
            <span className="flex items-center gap-1">
              <i className="ri-eye-line text-[10px]"></i>
              {formatViews(comic.views)}
            </span>
            <span className="flex items-center gap-1">
              <i className="ri-heart-line text-[10px]"></i>
              {formatViews(comic.favorites)}
            </span>
          </div>
        )}
        {/* Tags */}
        <div className="flex flex-wrap gap-1.5 mt-2">
          {comic.tags.slice(0, 2).map((tag) => (
            <span
              key={tag}
              className="px-2 py-0.5 rounded-full text-[10px] bg-secondary-100 text-secondary-700"
            >
              {tag}
            </span>
          ))}
        </div>
      </div>
    </Link>
  );
}